import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import { useSearchParams } from "react-router-dom";
import Conversation from "../App/Conversation";
import ConversationList from "../App/ConversationList";

function MyConversations() {
  const [searchParams] = useSearchParams();
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);
  const [screenListData, setScreenListData] = useState<any>([]);
  const [screenData, setScreenData] = useState<any>([]);

  const [sendWAMessage, setSendWAMessage] = useState(false);
  const [isConversation, setIsConversation] = useState(true);
  const [conversationID, setConversationID] = useState<number>(0);
  const [otherEntityID, setOtherEntityID] = useState<number>(0);

  const messageTypeID = 3;

  const handleConversationSelect = (data: {
    Status: number;
    ConversationID: number;
  }) => {
    if (data.Status === 1) {
      setOtherEntityID(data.ConversationID);
      setIsConversation(false); 
    }
  };

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      <div className="mn-convo-001">
        {/* Tabs */}
        {/* <div className="convo-tabs">
          <a
            className={isConversation ? "convo-select" : ""}
            onClick={() => setIsConversation(true)}
          >
            Conversations
          </a>
          <a
            className={!isConversation ? "convo-select" : ""}
            onClick={() => setIsConversation(false)}
          >
            Messages
          </a>
        </div> */}

        <div className="mn-convo">
          <div
            className={`mn-convo-1 ${isConversation ? "" : "mn-convo-hide"}`}
          >
            <ConversationList
              conversationID={conversationID}
              sendWAMessage={sendWAMessage}
              onConversationSelect={handleConversationSelect}
              isAdmin={true}
            />
          </div>

          {otherEntityID > 0 && (
            <div
              className={`mn-convo-1 ${isConversation ? "mn-convo-hide" : ""}`}
            >
              <Conversation
                OtherEntityID={otherEntityID}
                MessageTypeID={messageTypeID}
                SendWAMessage={sendWAMessage}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyConversations;
